import { FC } from 'react'
import Link from 'next/link'
import { ICompanyBase } from '@/types'
import { Avatar2 } from '@/componentsV2/atoms/Avatar2'
import { getCompanyLogo } from '@/utils'
import classNames from 'classnames'
import styles from './index.module.scss'

type Props = {
  company: ICompanyBase
  size?: 'sm' | 'md' | 'lg' | 'xl'
  date?: string
}

export const CompanyLogoAndName: FC<Props> = ({ company, size = 'md', date }) => {
  const logo = classNames(styles.logo, {
    [styles.mdLogo]: size === 'sm' || size === 'md',
    [styles.xlLogo]: size === 'lg' || size === 'xl',
  })
  const nameContent = classNames(styles.nameContent, {
    [styles.mdWidth]: size === 'sm' || size === 'md',
    [styles.xlWidth]: size === 'lg' || size === 'xl',
  })
  const name = classNames(styles.name, {
    [styles.mdFont]: size === 'sm' || size === 'md',
    [styles.xlFont]: size === 'lg' || size === 'xl',
  })
  return (
    <div className={styles.container}>
      <Link href={`/companies/${company?.slug}`}>
        <a className={styles.link}>
          <div className={logo}>
            <Avatar2 src={getCompanyLogo(company)} alt={company?.name} size={size} />
          </div>
          {date ? (
            <div className={nameContent}>
              <div className={name}>{company?.name}</div>
              <div className={styles.date}>{date}</div>
            </div>
          ) : (
            <div className={name}>{company?.name}</div>
          )}
        </a>
      </Link>
    </div>
  )
}
